var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('p',{staticClass:"jbrowse-genome"},[_vm._v("JBrowse("+_vm._s(_vm.genome)+")")]),_c('iframe',{ref:"iframe",attrs:{"id":"bdIframe","src":_vm.getUrl(),"frameborder":"0","scrolling":"yes"}})])}
var staticRenderFns = []

export { render, staticRenderFns }